import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../App";
import { ArrowLeft, ShieldAlert, ChevronDown, ChevronUp } from "lucide-react";

export default function MythBuster() {
  const navigate = useNavigate();
  const [myths, setMyths] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/myths/all").then(res => {
      setMyths(res.data.myths);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#F7931A] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="myth-buster-page">
      <header className="sticky top-0 z-50 glass-darker border-b border-white/5">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <button onClick={() => navigate("/dashboard")} className="text-zinc-400 hover:text-white">
            <ArrowLeft size={20} />
          </button>
          <h1 className="font-heading text-xl font-bold text-white">MYTH <span className="text-[#F7931A]">BUSTER</span></h1>
          <ShieldAlert className="text-[#F7931A]" size={20} />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        <p className="text-zinc-400 text-sm text-center mb-8">
          21 Bitcoin myths destroyed with facts. Tap to reveal the truth.
        </p>
        <div className="space-y-3">
          {myths.map((myth, i) => (
            <motion.div key={myth.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.03 }}
              className="card-dark overflow-hidden cursor-pointer"
              onClick={() => setExpanded(expanded === myth.id ? null : myth.id)}
              data-testid={`myth-${myth.id}`}
            >
              <div className="p-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="font-mono text-[#F7931A] text-xs font-bold w-6">#{myth.id}</span>
                  <p className="text-white text-sm font-medium">&quot;{myth.myth}&quot;</p>
                </div>
                {expanded === myth.id ? <ChevronUp className="text-zinc-500" size={18} /> : <ChevronDown className="text-zinc-500" size={18} />}
              </div>
              {expanded === myth.id && (
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}
                  className="px-4 pb-4 border-t border-white/5"
                >
                  <p className="text-[#F7931A] text-xs font-bold mt-3 mb-2">BUSTED:</p>
                  <p className="text-zinc-300 text-sm leading-relaxed">{myth.bust}</p>
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
      </main>
    </div>
  );
}
